import styled from 'styled-components';

export const DetailSearchWrapper = styled.div<{
  sticky?: boolean;
  withPackageTab?: boolean;
  animated: boolean;
}>`
  margin: 0 auto;
  ${({ sticky, animated, withPackageTab }) => `
    margin-top: ${sticky ? '0' : withPackageTab ? '10px' : '32px'};
    padding: ${sticky ? '10px 0 10px 10px' : '0'};
    position: ${sticky && animated ? 'fixed' : 'initial'};
    width: ${sticky ? '100vw' : 'fit-content'};
    `}
  z-index: 999;
  left: 0;
  top: ${({ animated, sticky }) => (sticky && animated ? '0' : '-200px')};

  display: flex;
  transition: all 0.35s;

  background-color: ${({ sticky, theme }) =>
    sticky ? theme.palette.white : 'transparent'};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0;
  }
`;

export const DetailSearchBarContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;

export const SearchBarWrapper = styled.div`
  max-width: fit-content;

  & > div {
    max-width: 1240px;
    width: 1240px;
    grid-template-columns: repeat(3, 330px) 190px;
    @media (max-width: 1268px) {
      grid-template-columns: repeat(3, 315px) 150px;
    }
  }
`;

export const InVisibleSearchBatPlaceHolder = styled.div`
  width: 100%;
  height: 98px;
`;
